import FiscalInventarioService from "@/services/FiscalInventarioService";

export const fiscalInventario = {
  namespaced: true,
  state: {},
  actions: {
    getFiscalInventarioSnapshots() {
      return FiscalInventarioService.GetSnapshots().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getFiscalInventario(_, id) {
      return FiscalInventarioService.GetInventario(id).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postFiscalInventarioSnapshot(_, payload) {
      return FiscalInventarioService.PostSnapshot(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postFiscalInventario(_, payload) {
      return FiscalInventarioService.PostInventario(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putFiscalInventario(_, { id, payload }) {
      return FiscalInventarioService.PutInventario(id, payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteFiscalInventario(_, id) {
      return FiscalInventarioService.DeleteInventario(id).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putFiscalInventarioItem(_, { id, itemId, payload }) {
      return FiscalInventarioService.PutInventarioItem(
        id,
        itemId,
        payload
      ).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteFiscalInventarioItem(_, { id, itemId }) {
      return FiscalInventarioService.DeleteInventarioItem(id, itemId).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    printFiscalInventario(_, id) {
      return FiscalInventarioService.PrintInventario(id).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    exportFiscalInventario(_, id) {
      return FiscalInventarioService.ExportInventario(id).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
  },
  mutations: {},
};

export default fiscalInventario;
